import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=830ef2d4&scoped=true"
import script from "./TemplateConfig.vue?vue&type=script&lang=js"
export * from "./TemplateConfig.vue?vue&type=script&lang=js"
import style0 from "./TemplateConfig.vue?vue&type=style&index=0&id=830ef2d4&prod&lang=css"
import style1 from "./TemplateConfig.vue?vue&type=style&index=1&id=830ef2d4&prod&scoped=true&lang=css"
import style2 from "./TemplateConfig.vue?vue&type=style&index=2&id=830ef2d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830ef2d4",
  null
  
)

export default component.exports